<template>
  <Scroll :on-reach-bottom="handleReachBottom" height="750" :distance-to-edge="[0,10]">
    <div class="kucun">
      <div class="topBar">
        <div class="daohang">
          <span
            @click="tiaozhuan"
            style="cursor: pointer; font-size:20px;color:#2d8cf0;font-family:'微软雅黑' "
          >
            <Icon type="ios-home"></Icon>
            {{languages.shouye}}
          </span>>
          <span
            style="cursor: pointer; font-size:20px;font-family:'微软雅黑'"
          >{{languages.yichukuchaxun}}</span>
        </div>
        <div class="iptc">
          <div class="iptlis">
            <Icon type="ios-search" class="ico"></Icon>
            <input
              class="iptli"
              :placeholder="languages.chaxunqingdianjiwo"
              type="primary"
              @click="showserch"
            >
            <div class="numEve">
              <div class="numlitter">{{languages.gong}}{{numnum}}{{languages.tiao}}</div>
            </div>
          </div>
        </div>
      </div>
      <modal class="serchlist" v-model="modal1" width="86%" :styles="{top: '60px',left:'100px'}">
        <div class="pz">
          <Select
            :placeholder="languages.qingxuanze"
            type="text"
            v-model="numpinzhong"
            clearable
            style="width: 200px"
          >
            <Option v-for="item in selectDatta" :value="item" :key="item"></Option>
          </Select>
          <span class="pinzhongs">{{languages.pinzhong}}</span>
        </div>
        <div class="ph">
          <Select
            :placeholder="languages.qingxuanze"
            type="text"
            filterable
            v-model="numpaihao"
            clearable
            style="width: 200px"
          >
            <Option v-for="item in shopDatta" :value="item" :key="item"></Option>
          </Select>
          <span class="paihaos">{{languages.paihao}}</span>
        </div>
        <div class="hou">
          <Input type="text" v-model="numhou" clearable style="width: 200px"></Input>

          <span class="hous">{{languages.hou}}</span>
        </div>
        <div class="kuan">
          <Input type="text" v-model="numkuan" clearable style="width: 200px"></Input>

          <span class="kuans">{{languages.kuan}}</span>
        </div>
        <div class="chang">
          <Input type="text" v-model="numchang" clearable style="width: 200px"></Input>

          <span class="changs">{{languages.chang}}</span>
        </div>
        <div class="ck">
          <Select
            :placeholder="languages.qingxuanze"
            type="text"
            v-model="numcangku"
            clearable
            style="width: 200px"
          >
            <Option v-for="item in  wareDatta" :value="item" :key="item"></Option>
          </Select>
          <span class="cangkus">{{languages.cangku}}</span>
        </div>
        <div class="mujs">
          <!-- <DatePicker confirm type="daterange" v-model='paramssubData' format="yyyy/MM/dd"  placement="bottom-end" placeholder="Select date" style="width: 200px" @on-change="getDateTime"></DatePicker> -->
          <DatePicker
            type="daterange"
            v-model="paramssubData"
            @on-change="getDateTime"
            placeholder="Select date"
            style="width: 200px"
            class="dataipt"
          ></DatePicker>
          <span>{{languages.chukushijian}}</span>
        </div>
        <div class="kunb">
          <Input type="text" v-model="numkunbaohao" clearable style="width: 200px"></Input>

          <span class="kunbaohaos">{{languages.kunbaohao}}</span>
        </div>
        <div class="muj">
          <Input type="text" v-model="nummujuanhao" clearable style="width: 200px"></Input>

          <span class="mujuanhaos">{{languages.mujuanhao}}</span>
        </div>
        <div class="chanpinyuanliao">
          <Select
            :placeholder="languages.qingxuanze"
            name
            id
            v-model="cpyl"
            clearable
            style="width: 200px"
          >
            <Option v-for="item in cityList2" :value="item.value" :key="item.value">{{item.label}}</Option>
            <!--                     <Option label="原料" value="MATERIAL">{{language.yuanliao}}</Option>
            <Option label="成品" value="PRODUCT">{{language.chengpin}}</Option>-->
          </Select>
          <span class="cunhuo">{{languages.cunhuoxingzhi}}</span>
        </div>
        <div class="chukuleixing">
          <Select name v-model="cklx" clearable style="width: 200px">
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{item.label}}</Option>
            <!-- <Option label="移库出库" value="YKOUT">移库出库</Option>
                    <Option label="销售出库" value="XSOUT">销售出库</Option>
                    <Option label="加工出库" value="JGOUT">加工出库</Option>
                    <Option label="仓储出库" value="CCOUT">仓储出库</Option>
                    <Option label="采购退货出库" value="CGOUT">采购退货出库</Option>
                    <Option label="赠送出库" value="ZSCK">赠送出库</Option>
                    <Option label="委外销售出库" value="WWXSCK">委外销售出库</Option>
                    <Option label="贸易委外销售出库" value="WWXSOUT">贸易委外销售出库</Option>
                    <Option label="原料委外出库" value="YLWWCK">原料委外出库</Option>
                    <Option label="来料出库" value="LLOUT">来料出库</Option>
                    <Option label="预售出库" value="YSOUT">预售出库</Option>
                    <Option label="分选出库" value="FXOUT">分选出库</Option>
            <Option label="换货出库" value="HHOUT">换货出库</Option>-->
          </Select>
          <span class="cunhuo">{{languages.chukuleixing}}</span>
        </div>
        <div slot="footer" style="background-color:rgb(249,249,249);">
          <div class="chaxun" @click="chaxun()">{{languages.chaxun}}</div>
          <div class="chongzhi" @click="chongzhis()">{{languages.chongzhi}}</div>
        </div>
      </modal>

      <table class="gridtable" v-show="tabshow" v-for="x in restab" :key="x">
        <tr class="returnButton" @click="returnButton">
          <td colspan="12" style="text-align:right;cursor:pointer">
            <span style="margin-right:3px;">{{languages.guanbi}}</span>
            <Icon type="close-circled"></Icon>
          </td>
        </tr>
        <tr>
          <th>{{languages.zhengshuhao}}</th>
          <td>{{x.tcNumTc}}</td>
          <th>{{languages.chenpinpinming}}</th>
          <td>{{x.prodName}}</td>
          <th>{{languages.hetonghao}}</th>
          <td>{{x.orderNum}}</td>
          <th>{{languages.jiaohuoriqi}}</th>
          <td>{{x.deliveryDateChr}}</td>
        </tr>
        <tr>
          <th>{{languages.gangjuanhao}}</th>
          <td>{{x.coilNumTc}}</td>
          <th>{{languages.kunbaohao}}</th>
          <td>{{x.packNum}}</td>
          <th>{{languages.luhao}}</th>
          <td>{{x.heatNumTc}}</td>
          <th>{{languages.hou}}</th>
          <td>{{x.thickTc}}</td>
        </tr>
        <tr>
          <th>{{languages.kuan}}</th>
          <td>{{x.widthTc}}</td>
          <th>{{languages.chang}}</th>
          <td>{{x.lengthTc}}</td>
          <th>{{languages.zhangshu}}</th>
          <td>{{x.n_pack}}</td>
          <th>{{languages.zhongliang}}</th>
          <td>T{{x.massTc}}</td>
        </tr>
        <tr>
          <th>{{languages.qufu}}</th>
          <td>{{x.yieldStrengthTq}}</td>
          <th>{{languages.kangla}}</th>
          <td>{{x.tensionStreTq}}</td>
          <th>{{languages.shenchang}}</th>
          <td colspan="6">{{x.elongationTq}}</td>
        </tr>
      </table>

      <!-- <div type="card"  v-model="nameTab"> -->
      <i-table border :columns="columns2" :data="data1"></i-table>
      <!-- </Tab-pane> -->

      <!-- </div>  -->
      <Col class="demo-spin-col" span="24" v-show="jiazai">
        <Spin fix>
          <Icon type="load-c" size="18" class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
      </Col>
      <div class="add_more_data">
        <!--             <p class="add_more_data_btn" v-show="moredata">
              {{language.jiazaigengduo}}
        </p>-->
        <p class="add_more_data_btn" v-show="!moredata">{{language.jiazaiwanbi}}</p>
      </div>
      <!--         <div class="add_more_down_load">
            <p class="add_more_all_weight">合计总重量： <span class="add_more_all_weight_span">{{weightAll}}</span>kg</p>
            <p class="add_more_add_more_down_load_btn" @click="downLoadData">

                <Icon type="archive" class="down"></Icon>
        数据下载
        </p>
      </div>-->

      <!-- <button @click="zhuxiang">111</button> -->
      <div class="bootBanner">
        <p class="liang">
          <!-- <span class="button_plan" @click="addTitles">
                    <span  style="margin-right:50px;"><Icon type="ios-compose"></Icon>提货</span>
          </span>-->
          <span class="add_more_all_weight">
            {{language.heji}}：
            <div class="add_more_all_weight_span">{{weightAll}}</div>kg
          </span>
          <span class="add_more_add_more_down_load_btn" @click="downLoadData">
            <Icon type="archive" class="down"></Icon>
            {{language.shujuxiazai}}
          </span>
        </p>
      </div>
      <!-- <button @click="zhuxiang()">1111</button> -->
    </div>
  </Scroll>
</template>	
<style scoped>
.kucun {
  margin-bottom: 90px;
}
.bootBanner {
  overflow: hidden;
  min-width: 100%;
  margin-top: 50px;
  position: fixed;
  bottom: -5px;
  margin-top: 30px;
  z-index: 10;
  /*height: 70px;*/
  overflow: hidden;
  margin-top: 300px;
}
.bootBanner span span {
  float: right;
  width: 120px;
  height: 70px;
  line-height: 70px;
  border: 1px solid #ccc;
  text-align: center;
  background-color: #1d92be;
  cursor: pointer;
  font-size: 18px;
  margin-right: 5px;
  display: block;
}
/*.boo*/
.bootBanner .ivu-icon {
  margin-right: 5px;
  color: #ffffff;
  font-size: 20px;
}
.bootBanner .liang {
  background-color: #e5ebf2;
  display: block;
  /*width: %;*/
  height: 100px;
  margin-right: 150px;
  /*margin-top:30px;*/
  /*position: fixed;*/
  /*bottom: -10px;*/
  /*margin-right: 20px;*/
}
.serchlist .pz span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .chanpinyuanliao span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .chukuleixing span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .mujs span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .pz,
.ph,
.hou,
.kuan,
.chang,
.ck,
.kunb,
.muj,
.chanpinyuanliao,
.mujs,
.chukuleixing {
  position: relative;
  /*float: left;*/
  margin-left: 50px;
  margin-top: 20px;
  display: inline-block;
}
.serchlist .ph span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .hou span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .kuan span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .chang span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .ck span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .kunb span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
}
.serchlist .muj span {
  position: absolute;
  left: 10px;
  top: -18px;
  height: 20px;
  width: 60px;
}
table.gridtable {
  width: 800px;
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
  position: fixed;
  z-index: 11;
  top: 200px;
  left: 400px;
  padding-top: 30px;
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ccc;
  background-color: #e6effa;
  color: #666666;
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ccc;
  background-color: #ffffff;
  color: #666666;
}
.numlitter {
  margin-right: 30px;
}

.iptlis {
  position: relative;
}
.iptlis .ico {
  position: absolute;
  right: 288px;
  top: 25px;
  z-index: 11111;
}

.numEve {
  position: absolute;
  right: 61px;
  top: 16px;
  line-height: 30px;
  background-color: #ffffff;
  height: 30px;
  width: 250px;
  text-align: right;
  color: #0066ff;
}
.iptc {
  height: 65px;
  position: relative;
  /*background:url(../assets/red.jpg);*/
  background: url(../assets/header.gif) repeat-x 0 0px;
  background-color: #cdd9e8;
  /*border-color: #8ba0bc;*/
}
.iptli {
  width: 140px;
  border: none;
  height: 24px;
  position: absolute;
  right: 170px;
  top: 19px;
  cursor: pointer;
  background-color: #eaeaea;
  padding-left: 30px;
  /*box-shadow: 3px 6px 6px 2px #E6E3F5;*/
  text-align: left;
  border-radius: 3px;
  z-index: 10;
  /*border-shadow:3px 6px;*/
  /*position: relative;*/
}
.topBar {
  position: relative;
}
.daohang {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 10;
  /*z-index: 10;*/
  margin-left: 20px;
  margin-top: 10px;
}
.down {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 40px;
  font-size: 30px;
  /*background-color:#fff;*/
}

.chaxun,
.chongzhi {
  width: 120px;
  height: 40px;
  background-color: #1d92be;
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  color: #f5f5f5;
  /*margin-top: 40px;*/
  display: inline-block;
  margin-right: 350px;
}

.serchlist input {
  width: 180px;
  height: 40px;
  /*margin-top:30px;*/
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.serchlist span {
  width: 50px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  background-color: white;
}

.add_more_down_load {
  width: 100%;
  height: 100px;
  position: relative;
  bottom: 0;
  background-color: #e5ebf2;
}
.add_more_all_weight {
  width: 250px;
  height: 80px;
  line-height: 80px;
  position: absolute;
  top: 5px;
  left: 5px;
  text-align: center;
  background-color: #e5ebf2;
}
.add_more_all_weight_span {
  color: red;
  display: inline-block;
}
.add_more_add_more_down_load_btn {
  width: 120px;
  height: 100px;
  line-height: 100px;
  float: right;
  margin-right: 60px;
  position: relative;
  /*display: inline-block;*/
  /*position: absolute;*/
  /*top: 0px;*/
  /*right:8px;*/
  text-align: center;
  cursor: pointer;
  background-color: #1d92be;
  color: #fff;
}
.add_more_add_more_down_load_btn_span {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 10px;
  right: 35px;
  background-color: #fff;
}
.add_more_data {
  width: 100%;
  height: 60px;
  position: relative;
}
.add_more_data_btn {
  /*width:120px;*/
  height: 40px;
  line-height: 40px;
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  cursor: pointer;
}
.add_more_data_btn:hover {
  color: #2d8cf0;
}
.ivu-table-cell {
  text-align: center;
}
.ivu-table-cell span {
  text-align: center;
}
.ivu-tabs ivu-tabs-card {
  width: 100%;
}
.ivu-tabs {
  width: 100%;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import config from "config/apiConfig";
import language from "api/language";
export default {
  data() {
    return {
      // changeNewData:0,
      nameTab: "addmeauTwo",
      languages: {},
      data1: [],
      variety: "",
      mark: "",
      Thickness: "",
      wide: "",
      long: "",
      warehouse: "",
      Bundle: "",
      volume: "",
      loadnum: [],
      addMoreData: true,
      numpinzhong: "",
      numpaihao: "",
      numhou: "",
      numchang: "",
      numkuan: "",
      numcangku: "",
      numkunbaohao: "",
      nummujuanhao: "",
      cpyl: "",
      cklx: "",
      numnum: "",
      raval: false,
      weightAll: 0,
      tabshow: false,
      restab: [],
      selectDatta: [],
      shopDatta: [],
      modal1: false,
      wareDatta: [],
      paramssubData: [],
      dataMoRen1: "",
      dataMoRen2: "",
      moRenDate: "",
      moRenDates: "",
      value2: [],
      newArr: [],
      newArrs: [],
      newArrss: [],
      stockDate: "",
      stockDateTo: "",
      flag: 0,
      jiazai: false,
      moredata: true,
      cityList2: [
        {
          value: "MATERIAL",
          label: language.yuanliao
        },
        {
          value: "PRODUCT",
          label: language.chengpin
        }
      ],
      cityList: [
        {
          value: "YKOUT",
          // label: '移库出库',
          label: language.yikuchuku
        },
        {
          value: "XSOUT",
          // label: '销售出库',
          label: language.xiaoshouchuku
        },
        {
          value: "JGOUT",
          // label: '加工出库',
          label: language.jiagongchuku
        },
        {
          value: "CCOUT",
          // label: '仓储出库',
          label: language.cangchuchuku
        },
        {
          value: "CGOUT",
          // label: '采购退货出库',
          label: language.caigoutuihuochuku
        },
        {
          value: "ZSCK",
          // label: '赠送出库',
          label: language.zengsongchuku
        },
        {
          value: "WWXSCK",
          // label: '委外销售出库',
          label: language.weiwaixiaoshouchuku
        },
        {
          value: "WWXSOUT",
          // label: '贸易委外销售出库'
          label: language.maoyiweiwaixiaoshouchuku
        },

        {
          value: "YLWWCK",
          // label: '原料委外出库'
          label: language.yuanliaoweiwaichuku
        },
        {
          value: "LLOUT",
          // label: '来料出库'
          label: language.lailiaochuku
        },
        {
          value: "YSOUT",
          // label: '预售出库'
          label: language.yushouchuku
        },
        {
          value: "FXOUT",
          // label: '分选出库'
          label: language.fenxuanchuku
        },
        {
          value: "HHOUT",
          // label: '换货出库'
          label: language.huanhuochuku
        }
      ],
      // res:[],
      // value2: ['dataMoRen1','dataMoRen2'],
      columns2: [
        {
          title: language.shouhuokehu,
          minWidth: 130,
          align: "center",
          key: "customerName"
        },
        {
          title: language.cangku,
          minWidth: 60,
          align: "center",
          key: "warehouseName"
        },
        {
          title: language.picihao,
          minWidth: 120,
          align: "center",
          key: "imResourceId"
        },
        {
          title: language.chengpinkunbaohao,
          minWidth: 100,
          align: "center",
          key: "serialCode"
        },
        {
          title: language.pinming,
          minWidth: 70,
          align: "center",
          key: "categoryCode"
        },
        {
          title: language.paihao,
          minWidth: 80,
          align: "center",
          key: "shopsign"
        },
        {
          title: language.guige,
          minWidth: 100,
          align: "center",
          key: "specdesc"
        },
        {
          title: language.zhongliang,
          minWidth: 80,
          align: "center",
          key: "primaryQty"
        },
        {
          title: language.shuliang,
          minWidth: 60,
          minWidth: 60,
          align: "center",
          key: "secondQty"
        },
        {
          title: language.neiwaiban,
          minWidth: 80,
          align: "center",
          key: "exposedName"
        },
        {
          title: language.duxinceng,
          key: "extCol12",
          align: "center",
          minWidth: 90
        },
        {
          title: language.chukuriqi,
          minWidth: 100,
          align: "center",
          key: "storeDate"
        },
        {
          title: language.mujuanhao,
          minWidth: 90,
          align: "center",
          key: "reelno"
        },
        {
          title: language.mujuanguige,
          align: "center",
          minWidth: 100,
          key: "rawSpecdesc"
        },
        {
          title: language.mujuanzhongliang,
          minWidth: 80,
          align: "center",
          key: "rawPrimaryQty"
        },

        {
          title: language.laiyuanleixing,
          minWidth: 80,
          align: "center",
          key: "fromTypeName"
        },
        {
          title: language.kuweimingcheng,
          minWidth: 75,
          align: "center",
          key: "locationCode"
        },
        {
          title: language.zhujiliangdanwei,
          minWidth: 100,
          align: "center",
          key: "primaryMeasureUnitName"
        },
        {
          title: language.zhudanweishuliang,
          minWidth: 95,
          align: "center",
          key: "transactionQty"
        },
        {
          title: language.gangchangziyuanhao,
          align: "center",
          minWidth: 130,
          key: "gcresourceCode"
        },
        {
          title: language.rukuriqi,
          minWidth: 120,
          align: "center",
          key: "stockInDate"
        },
        {
          title: language.caozuo,
          minWidth: 120,
          align: "center",
          key: "address",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  on: {
                    click: () => {
                      this.openzb(params);
                    }
                  },
                  style: {
                    border: "1px solid white",
                    backgroundColor: "white",
                    fontSize: "18px",
                    color: "ccc"
                  }
                },
                [
                  h("icon", {
                    props: {
                      type: "ios-book"
                    }
                    // style:{
                    //     border:'1px solid white'
                    // },
                  })
                ]
              ),
              h(
                "Button",
                {
                  on: {
                    click: () => {
                      this.openza(params);
                    }
                  },
                  style: {
                    border: "1px solid white",
                    backgroundColor: "white",
                    fontSize: "18px",
                    color: "ccc"
                  }
                },
                [
                  h("icon", {
                    props: {
                      type: "stats-bars"
                    }
                    // style:{
                    //     border:'1px solid white'
                    // },
                  })
                ]
              )
            ]);
          }
        }
      ],
      data2: []
    };
  },

  methods: {
    chuku() {
      let that = this;
      that.cklx = "XSOUT";
    },
    handleReachBottom() {
      return new Promise(update => {
        setTimeout(() => {
          let that = this;
          // let date=new Date();
          //             let year=date.getFullYear();
          //             let month=date.getMonth()+1;
          //             let moRenDate = year+'-'+month+'-01';
          //             let allDays = new Date(year,month,0).getDate();
          //             let arrmoRenDate = year+'-'+month+'-'+allDays;
          //             let newArrs = [];
          //             that.newArrs.push(moRenDate,arrmoRenDate);
          //             that.paramssubData=that.newArrs;
          // that.resl=0;
          // console.log(index)
          let paramsData;
          // if(index==10){
          paramsData = {
            offset: that.data1.length,
            limit: "10",
            categoryCode: that.numpinzhong,
            shopsign: that.numpaihao,
            thickness: that.numhou,
            length: that.numchang,
            width: that.numkuan,
            warehouseName: that.numcangku,
            serialCode: that.numkunbaohao,
            reelNo: that.nummujuanhao,
            stockType: that.cpyl,
            fromType: that.cklx
          };
          if (that.flag == 0) {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let moRenDate = year + "-" + month + "-01";
            let allDays = new Date(year, month, 0).getDate();
            let arrmoRenDate = year + "-" + month + "-" + allDays;
            let newArrs = [];
            that.newArrs.push(moRenDate, arrmoRenDate);
            that.paramssubData = that.newArrs;
            paramsData.stockDateFrom = that.paramssubData[0];
            paramsData.stockDateTo = that.paramssubData[1];
          } else {
            paramsData.stockDateFrom = that.stockDate;
            paramsData.stockDateTo = that.stockDateTo;
          }

          if (that.data1.length % 10 != 0) {
            that.moredata = false;
            that.jiazai = false;
            return;
          }
          if (
            that.totalPageCount % 10 == 0 &&
            that.data1.length == that.totalPageCount
          ) {
            that.moredata = false;
            that.jiazai = false;
            return;
          }
          that.jiazai = true;

          axios.post(config.bbb, paramsData).then(function(response) {
            if (response.data.resultCode == 1) {
          update();
              
              that.jiazai = false;
              that.data1 = that.data1.concat(response.data.resultData);
              that.$Message.info(language.jiazaiwanbi);
              that.weightAll = response.data.page.totalWeight;
              //     for(var i=0; i<response.data.resultData.length; i++){
              //     // console.log(response.data.resultData.length)
              //     that.weightAll+=parseInt(response.data.resultData[i].primaryQty)
              // }
            } else {
              that.$Message.info(response.data.fsuffix);
            }

            // alert(response.data.fsuffix)
          });

          return;
          // }
        }, 500);
      });
    },
    showserch(value) {
      let that = this;
      // console.log(that.changeNewData)
      // if(that.modal1==false){
      that.modal1 = true;
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let moRenDate = year + "-" + month + "-01";
      let allDays = new Date(year, month, 0).getDate();
      let arrmoRenDate = year + "-" + month + "-" + allDays;
      let newArr = [];
      newArr.push(moRenDate, arrmoRenDate);
      if (that.flag == 0) {
        that.paramssubData = that.newArr;
      }
      // console.log(that.flag)
      // console.log(value)
      // newArr = []
      // console.log(that.paramssubData)
      // that.paramssubData.subData=that.newArr[0];
      // that.paramssubData.subData2=that.newArr[1];
      // console.log(that.paramssubData.subData)
      // console.log(that.paramssubData.subData2)
      // console.log(moRenDates)
    },
    openzb(a) {
       //获取token
                let access_token="";
                axios.post(config.getBspAccessToken).then(function(response){
                    console.log(response)
                    if(response.status==200){
                        debugger;
                        access_token= response.data;
                        console.log(access_token);
                        let bsteelUrl=JSON.parse(localStorage.getItem("bsteelUrl"));
                         console.log(bsteelUrl);
                        if(a.row.gcresourceCode!=null){
                        // let url ="http://ecommerce.ibaosteel.com/"+"baosteel_csm/ce/tLfqmActionCas.cas?downFlag=0&uCode=U07266&saleNetwork=A&companyNo=3N044&system=NS&userNo=U07266_060&orderNum=MN3BJ15002&printFlag=0&userNum=900001&access_token="+access_token;
                        let url =bsteelUrl+"baosteel_csm/ce/tLfqmActionCas.cas?downFlag=0&uCode=U07266&saleNetwork=A&companyNo=3N044&system=NS&userNo=U07266_060&orderNum="+a.row.gcresourceCode+"&printFlag=0&userNum=900001&access_token="+access_token;
                       window.open(url)
                        }
                    }
                    else{
                        that.$Message.warning({
                                    content: language.gangchangziyuanhaoweikongbunengchakan,
                                    duration: 10,
                                    closable: true
                        })
                    }
                })
    },

    getDateTime(value) {
      console.log(value);
      let that = this;
      that.flag = 1;
      // if(that.flag==0){

      that.paramssubData = value;
      // that.

      // }
      // let that = this
      // let subData=''
      // let subData2=''
      // let that = this
      // for(var i=0;i<value.length;i++){
      // console.log(value[i])
      console.log(value);
      // this.changeNewData = 1;
      // that.paramssubData.subData2=value[1]
      // }
      // console.log(that.paramssubData.subData)
      // console.log(that.paramssubData.subData2)
    },
    warehouseNameDrop() {
      let that = this;
      axios.post(config.warehouseNameDrop, {}).then(function(response) {
        let resultDatas = response.data.resultData;
        for (var i = 0; i < resultDatas.length; i++) {
          if (resultDatas[i].warehouseName != null) {
            that.wareDatta.push(resultDatas[i].warehouseName);
          }
          // console.log(resultData[i].categoryCode)
          // console.log(response)
        }
      });
    },
    shopsignDrop() {
      let that = this;
      axios.post(config.shopsignDrop, {}).then(function(response) {
        // console.log(1)
        // console.log(response.data.resultData)
        let resultDatas = response.data.resultData;
        for (var i = 0; i < resultDatas.length; i++) {
          if (resultDatas[i].shopsign != null) {
            that.shopDatta.push(resultDatas[i].shopsign);
          }
          // console.log(resultData[i].categoryCode)
          // console.log(that.shopDatta)
        }
      });
    },
    selectType() {
      let that = this;
      axios.post(config.categoryCodeDrop, {}).then(function(response) {
        // console.log(response.data.resultData)
        let resultData = response.data.resultData;
        for (var i = 0; i < resultData.length; i++) {
          if (resultData[i].categoryCode != null) {
            that.selectDatta.push(resultData[i].categoryCode);
          }
          // console.log(resultData[i].categoryCode)
          // console.log(that.selectDatta)
        }
      });
    },
    returnButton() {
      if (this.tabshow == true) {
        this.tabshow = false;
      }
    },
    openza(a) {
      let that = this;
      let paramsData = {
        // orderNum: a.row.gcresourceCode,
        packNum: a.row.reelno,
        prodCode: "",
        dateFrom: "",
        dateTo: ""
      };
      console.log(111);
      axios.post(config.QualityInfos, paramsData).then(function(response) {
        let res = response.data.resultData;

        console.log(res)
        if (response.data.resultCode==1) {
          console.log(3333);
          that.tabshow = true;
          that.restab = response.data.resultData.list;
        }
        if (that.restab.length == 0) {
          that.$Message.info(language.shujuweikong);
        }
      });
    },
    tiaozhuan() {
      this.$router.push({ name: "firstpage", params: { id: "1" } });
    },
    chaxun() {
      //
      let that = this;
      // let date=new Date();
      //             let year=date.getFullYear();
      //             let month=date.getMonth()+1;
      //             let moRenDate = year+'-'+month+'-01';
      //             let allDays = new Date(year,month,0).getDate();
      //             let arrmoRenDate = year+'-'+month+'-'+allDays;
      //             let newArrs = [];
      //             that.newArrs.push(moRenDate,arrmoRenDate);
      //             that.paramssubData=that.newArrs;

      let params = {};
      params.stockDateFrom = that.paramssubData[0];
      params.stockDateTo = that.paramssubData[1];
      params.categoryCode = that.numpinzhong;
      params.shopsign = that.numpaihao;
      params.thickness = that.numhou;
      params.length = that.numchang;
      params.width = that.numkuan;
      params.warehouseName = that.numcangku;
      params.serialCode = that.numkunbaohao;
      params.reelNo = that.nummujuanhao;
      params.stockType = that.cpyl;
      params.fromType = that.cklx;
      that.stockDate = params.stockDateFrom;
      that.stockDateTo = params.stockDateTo;
      // console.log(params.stockDateFrom)
      if (that.paramssubData == "") {
        that.$Message.info(language.qingxuanzejiaohuoqi);
      } else {
        that.$Message.info(language.qingshaodeng);

        axios.post(config.bbb, params).then(function(response) {
          if (response.data.resultCode == 1) {
            that.numnum = response.data.page.totalPageCount;
            console.log(response);
            that.data1 = response.data.resultData;
            that.weightAll = response.data.page.totalWeight;

            // console.log(that.addmeauDataOpen)
            that.$Message.info(language.chaxunchenggong);
            that.modal1 = false;
          } else if (response.data.resultCode == 0) {
            that.$Message.info(language.jiazaishibai);
          }
          // console.log(numnum)
        });
      }
    },
    // shenqingjiaohuo(){
    //     let that = this;
    //     let date=new Date();
    //                 let year=date.getFullYear();
    //                 let month=date.getMonth()+1;
    //                 let moRenDate = year+'-'+month+'-01';
    //                 let allDays = new Date(year,month,0).getDate();
    //                 let arrmoRenDate = year+'-'+month+'-'+allDays;
    //                 let newArrs = [];
    //                 that.newArrs.push(moRenDate,arrmoRenDate);
    //                 that.paramssubData=that.newArrs;
    //                 let params={};
    //                 params.stockDateFrom = that.paramssubData[0];
    //                 params.stockDateTo =  that.paramssubData[1];
    // },
    update(index) {
      let that = this;
      // let date=new Date();
      //             let year=date.getFullYear();
      //             let month=date.getMonth()+1;
      //             let moRenDate = year+'-'+month+'-01';
      //             let allDays = new Date(year,month,0).getDate();
      //             let arrmoRenDate = year+'-'+month+'-'+allDays;
      //             let newArrs = [];
      //             that.newArrs.push(moRenDate,arrmoRenDate);
      //             that.paramssubData=that.newArrs;
      // that.resl=0;
      // console.log(index)
      let paramsData;
      if (index == 10) {
        paramsData = {
          offset: that.data1.length,
          limit: "10",
          categoryCode: that.numpinzhong,
          shopsign: that.numpaihao,
          thickness: that.numhou,
          length: that.numchang,
          width: that.numkuan,
          warehouseName: that.numcangku,
          serialCode: that.numkunbaohao,
          reelNo: that.nummujuanhao,
          stockType: that.cpyl,
          fromType: that.cklx,
          fromType: "XSOUT"
        };
        if (that.flag == 0) {
          let date = new Date();
          let year = date.getFullYear();
          let month = date.getMonth() + 1;
          let moRenDate = year + "-" + month + "-01";
          let allDays = new Date(year, month, 0).getDate();
          let arrmoRenDate = year + "-" + month + "-" + allDays;
          let newArrs = [];
          that.newArrs.push(moRenDate, arrmoRenDate);
          that.paramssubData = that.newArrs;
          paramsData.stockDateFrom = that.paramssubData[0];
          paramsData.stockDateTo = that.paramssubData[1];
        } else {
          paramsData.stockDateFrom = that.stockDate;
          paramsData.stockDateTo = that.stockDateTo;
        }

        if (that.data1.length % 10 != 0) {
          that.moredata = false;
          return;
        }
        if (
          that.totalPageCount % 10 == 0 &&
          that.data1.length == that.totalPageCount
        ) {
          that.moredata = false;
          return;
        }
        axios.post(config.bbb, paramsData).then(function(response) {
          if (response.data.resultCode == 1) {
            that.data1 = that.data1.concat(response.data.resultData);
            that.$Message.info(language.jiazaiwanbi);
            that.weightAll = response.data.page.totalWeight;
            //     for(var i=0; i<response.data.resultData.length; i++){
            //     // console.log(response.data.resultData.length)
            //     that.weightAll+=parseInt(response.data.resultData[i].primaryQty)
            // }
          }
          // else{
          //     that.$Message.info(response.data.fsuffix)
          // }

          // alert(response.data.fsuffix)
        });

        return;
      }
    },
    chongzhis() {
      let that = this;
      // console.log(that.numpinzhong)
      that.numpinzhong = "";
      that.numpaihao = "";
      that.numhou = "";
      that.numchang = "";
      that.numkuan = "";
      that.numcangku = "";
      that.numkunbaohao = "";
      that.nummujuanhao = "";
      that.cpyl = "";
      that.cklx = "";
      that.paramssubData = "";
      // if(that.chongzhi==true){
      //     params.value=""
      // }
    },

    srechEve() {
      // alert("aaa")
      let that = this;
      if (that.raval == false) {
        that.raval = true;
      } else {
        that.raval = false;
      }
    },
    downLoadData() {
      let that = this;
      // let date=new Date();
      //         let year=date.getFullYear();
      //         let month=date.getMonth()+1;
      //         let moRenDate = year+'-'+month+'-01';
      //         let allDays = new Date(year,month,0).getDate();
      //         let arrmoRenDate = year+'-'+month+'-'+allDays;
      //         let newArrss = []
      //         that.newArrss.push(moRenDate,arrmoRenDate);
      //         that.paramssubData=that.newArrss;
      // newArr=[]
      // params.stockDateFrom = that.paramssubData[0];
      // params.stockDateTo =  that.paramssubData[1];
      let paramsData = {
        serialCode: "",
        categoryName: "",
        shopsign: "",
        reelNo: "",
        categoryCode: this.numpinzhong,
        shopsign: this.numpaihao,
        thickness: this.numhou,
        length: this.numchang,
        width: this.numkuan,
        warehouseName: this.numcangku,
        serialCode: this.numkunbaohao,
        reelNo: this.nummujuanhao,
        stockType: this.cpyl,
        fromType: this.cklx
        // "stockDateFrom" : that.paramssubData[0],
        // "stockDateTo" : that.paramssubData[1],
      };
      if (that.flag == 0) {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let moRenDate = year + "-" + month + "-01";
        let allDays = new Date(year, month, 0).getDate();
        let arrmoRenDate = year + "-" + month + "-" + allDays;
        let newArrs = [];
        that.newArrs.push(moRenDate, arrmoRenDate);
        that.paramssubData = that.newArrs;
        paramsData.stockDateFrom = that.paramssubData[0];
        paramsData.stockDateTo = that.paramssubData[1];
      } else {
        paramsData.stockDateFrom = that.stockDate;
        paramsData.stockDateTo = that.stockDateTo;
      }
      this.$Message.success({
        content: language.qingshaodeng,
        duration: 2,
        closable: true
      });
      axios({
        method: "post",
        url: config.outStockExpt2,
        data: paramsData,
        responseType: "blob"
      })
        .then(function(response) {
          const content = response.data;
          const blob = new Blob([content]);
          const fileName = "download.xls";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    zhuxiang() {
      // let that = this;
      // alert(1111)
      // params.stockDateFrom = that.paramssubData[0];
      // params.stockDateTo =  that.paramssubData[1];
      let that = this;
      that.language = language;
      that.$Message.info({
        content: language.shujujiazaiqingshaodeng,
        duration: 50
      });
      debugger;      
      let params = {};
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let moRenDate = year + "-" + month + "-01";
      let allDays = new Date(year, month, 0).getDate();
      let arrmoRenDate = year + "-" + month + "-" + allDays;
      // let newArr = []
      that.newArr.push(moRenDate, arrmoRenDate);
      that.paramssubData = that.newArr;
      debugger;
      // params.stockDateFrom = that.paramssubData[0];
      // params.stockDateTo = that.paramssubData[1];
      params.fromType = "XSOUT";
      params.stockDateFrom = that.paramssubData[0];
      params.stockDateTo =  that.paramssubData[1];
      params.categoryCode = that.numpinzhong;
      params.shopsign = that.numpaihao;
      params.thickness = that.numhou;
      params.length = that.numchang;
      params.width = that.numkuan;
      params.warehouseName = that.numcangku;
      params.serialCode = that.numkunbaohao;
      params.reelNo = that.nummujuanhao;
      params.stockType = that.cpyl;
      // params.fromType = that.cklx;

      axios.post(config.bbb, params).then(function(response) {
        if ((response.data.resultCode = 1)) {
          that.$Message.destroy();
          that.data1 = response.data.resultData;
          that.weightAll = response.data.page.totalWeight;
          console.log(response);
        }
      });
    }
  },
  mounted() {
    this.zhuxiang();
    this.selectType();
    this.shopsignDrop();
    this.warehouseNameDrop();
    this.chuku();
    this.languages = language;
    // this.chukuleixing()
  }
};
</script>



// WEBPACK FOOTER //
// addmeauTwo.vue?7ad56cd3